import { Trans } from "react-i18next";
import { backClickStatic } from "../../../pages/find-care-options/questions/Single";
import { getCommonRequestData } from "./utils";
import {
  checkAndGetLocalStorageValue,
  checkAndGetSessionStorageValue,
  generateJsonWebToken,
} from "../../../features/utils";
import { defaultCovidUrl } from "client.config";
import {
  genderConst,
  telemedicineVendors,
  commonConstant,
} from "../../../server/triage/constants";

export async function getTriageQuestions({ state, actions, getState }) {
  const encounterToken = checkAndGetLocalStorageValue("token");
  const success = await actions.sendTriageRequest({
    action: "getQuestions",
    data: getCommonRequestData({ state, encounterToken }),
  });

  if (success && success.message === commonConstant.success) {
    const { triageResponse = {} } = getState();
    return triageResponse.questions.length ? true : false;
  }

  return false;
}

export async function getTriageAdditionalQuestions({
  state,
  actions,
  getState,
}) {
  const encounterToken = checkAndGetLocalStorageValue("token");
  const success = await actions.sendTriageRequest({
    action: "getAdditionalQuestions",
    data: getCommonRequestData({ state, encounterToken }),
  });

  if (success) {
    const { triageResponse = {} } = getState();
    return triageResponse.additionalQuestions.length ? true : false;
  }

  return false;
}

export function clearTriageQuestions({ state, setState }) {
  setState({
    triageRequest: {
      ...state.triageRequest,
      answers: [],
      additionalAnswers: [],
    },
    triageResponse: {
      ...state.triageResponse,
      questions: [],
      additionalQuestions: [],
    },
  });
}

export async function getQuestionsByOrder(
  { state, actions, setState, nextStepName, history },
  lang,
  isQuestionLog
) {
  const { triageRequest } = state;
  let { ageInYears, gender, sessionId } = triageRequest;
  let genderFemale = "female";
  let genderMale = "male";
  if (triageRequest.gender === "F") gender = genderFemale;
  if (triageRequest.gender === "M") gender = genderMale;

  const dataResponse = getDataForGetDiagnosis(state, lang, isQuestionLog);

  setState({
    isLoading: true,
  });
  var totalOrderLength = state.orderIdArray.length;

  var orderId = state.orderIdArray[totalOrderLength - 1];
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");

  const encounterToken = checkAndGetLocalStorageValue("token");
  const data = {
    identifier: sessionId,
    token: encounterToken,
    order: orderId,
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
  };

  var response = await actions.sendTriageRequest({
    action: "GetInterviewQuestionByOrder",
    data,
  });

  if (response && response.message === commonConstant.success) {
    state.orderIdArray.splice(totalOrderLength - 1, 1);
    var questions = response.questions;
    var hintResponseValue = await actions.sendTriageRequest({
      action: "GetHint",
      data: {
        LanguageId: getLanguage(lang),
        Age: ageInYears,
        Gender: gender,
        Id: questions.question != null ? questions.question.items[0].id : "",
        PresentEvidence: dataResponse.PresentEvidence,
        AbsentEvidence: dataResponse.AbsentEvidence,
        UnknownEvidence: dataResponse.UnknownEvidence,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
      },
    });

    var hintResponse;
    if (
      hintResponseValue &&
      hintResponseValue.message === commonConstant.success
    ) {
      hintResponse = hintResponseValue.hintResponse;
      if (hintResponse != null) {
        this.state = {
          Hinttype1: hintResponse.type,
          Hinttype2:
            hintResponse.type != "r4" &&
            hintResponse.type != "r6" &&
            hintResponse.ConditionParams != null &&
            hintResponse.ConditionParams.length > 0
              ? hintResponse.ConditionParams[0].common_name
              : hintResponse.observation_params != null &&
                hintResponse.observation_params.length > 0
              ? hintResponse.observation_params[0].common_name
              : null,
        };
      }
      if (this.state.Hinttype1 == "r0") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h1">
            "I'm asking this question because a negative response reduces
            probability of "
          </Trans>
        );

        if (lang !== "de") {
          state.triageRequest.hint2 = (
            <Trans i18nKey="findcareoption.Hints.h11">
              " and other conditions."
            </Trans>
          );
        }
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r1") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h2">
            "I'm asking this question because "
          </Trans>
        );
        state.triageRequest.hint2 = (
          <Trans i18nKey="findcareoption.Hints.h21">
            "might be related with one or more considered conditions."
          </Trans>
        );
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r2") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h1">
            "I'm asking this question because a negative response reduces
            probability of "
          </Trans>
        );

        if (lang !== "de") {
          state.triageRequest.hint2 = (
            <Trans i18nKey="findcareoption.Hints.h11">
              " and other conditions."
            </Trans>
          );
        }
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r3") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h4">
            "I'm asking this question to either rule in or out conditions such
            as "
          </Trans>
        );
        state.triageRequest.hint2 = ".";
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r4") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h2">
            "I'm asking this question because "
          </Trans>
        );
        state.triageRequest.hint2 = (
          <Trans i18nKey="findcareoption.Hints.h51">
            " might be one of the causes of your symptoms."
          </Trans>
        );
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r5") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h6">
            "I'm asking this question because I want to know if you suffered any
            recent injury"
          </Trans>
        );
      }
      if (this.state.Hinttype1 == "r6") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h7">
            "I'm asking this question to learn more about your "
          </Trans>
        );
        state.triageRequest.hint2 = ".";
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      state.triageRequest.questions = questions;
      state.triageRequest.activeMenu = "questions";
      getQuestionCallback(
        state,
        actions,
        setState,
        nextStepName,
        history,
        lang,
        questions
      );
    }
  }
}

export async function getQuestions(
  { state, actions, setState, nextStepName, history },
  lang,
  isQuestionLog
) {
  const { triageRequest } = state;
  let { ageInYears, gender } = triageRequest;
  let genderFemale = "female";
  let genderMale = "male";
  if (triageRequest.gender === "F") gender = genderFemale;
  if (triageRequest.gender === "M") gender = genderMale;

  setState({
    isLoading: true,
    itemSelected: false,
    selectedAnswer: []
  });
  const data = getDataForGetDiagnosis(state, lang, isQuestionLog);

  window.store = store;
  var response = await actions.sendTriageRequest({
    action: "getDiagnosisQuestion",
    data,
  });

  if (response && response.message === commonConstant.success) {
    var questions = response.questions;
    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");
    var hintResponseValue = await actions.sendTriageRequest({
      action: "GetHint",
      data: {
        LanguageId: getLanguage(lang),
        Age: ageInYears,
        Gender: gender,
        Id: questions.question != null ? questions.question.items[0].id : "",
        PresentEvidence: data.PresentEvidence,
        AbsentEvidence: data.AbsentEvidence,
        UnknownEvidence: data.UnknownEvidence,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
      },
    });

    var hintResponse;
    if (
      hintResponseValue &&
      hintResponseValue.message === commonConstant.success
    ) {
      hintResponse = hintResponseValue.hintResponse;
      if (hintResponse != null) {
        this.state = {
          Hinttype1: hintResponse.type,
          Hinttype2:
            hintResponse.type != "r4" &&
            hintResponse.type != "r6" &&
            hintResponse.ConditionParams != null &&
            hintResponse.ConditionParams.length > 0
              ? hintResponse.ConditionParams[0].common_name
              : hintResponse.observation_params != null &&
                hintResponse.observation_params.length > 0
              ? hintResponse.observation_params[0].common_name
              : null,
        };
      }
      // state.triageRequest.hint3 ="";
      if (this.state.Hinttype1 == "r0") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h1">
            "I'm asking this question because a negative response reduces
            probability of "
          </Trans>
        );
        // if (lang==="de"){
        //   state.triageRequest.hint3 =
        //     <Trans i18nKey="findcareoption.Hints.h12"></Trans>
        //  }
        if (lang !== "de") {
          state.triageRequest.hint2 = (
            <Trans i18nKey="findcareoption.Hints.h11">
              " and other conditions."
            </Trans>
          );
        }
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r1") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h2">
            "I'm asking this question because "
          </Trans>
        );
        state.triageRequest.hint2 = (
          <Trans i18nKey="findcareoption.Hints.h21">
            "might be related with one or more considered conditions."
          </Trans>
        );
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r2") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h1">
            "I'm asking this question because a negative response reduces
            probability of "
          </Trans>
        );
        // if (lang==="de"){
        //   state.triageRequest.hint3 =
        //     <Trans i18nKey="findcareoption.Hints.h12"></Trans>
        //  }
        if (lang !== "de") {
          state.triageRequest.hint2 = (
            <Trans i18nKey="findcareoption.Hints.h11">
              " and other conditions."
            </Trans>
          );
        }
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r3") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h4">
            "I'm asking this question to either rule in or out conditions such
            as "
          </Trans>
        );
        state.triageRequest.hint2 = ".";
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r4") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h2">
            "I'm asking this question because "
          </Trans>
        );
        state.triageRequest.hint2 = (
          <Trans i18nKey="findcareoption.Hints.h51">
            " might be one of the causes of your symptoms."
          </Trans>
        );
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      if (this.state.Hinttype1 == "r5") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h6">
            "I'm asking this question because I want to know if you suffered any
            recent injury"
          </Trans>
        );
      }
      if (this.state.Hinttype1 == "r6") {
        state.triageRequest.hint1 = (
          <Trans i18nKey="findcareoption.Hints.h7">
            "I'm asking this question to learn more about your "
          </Trans>
        );
        state.triageRequest.hint2 = ".";
        state.triageRequest.hintsymptom = this.state.Hinttype2;
      }
      state.triageRequest.questions = questions;
      state.triageRequest.activeMenu = "questions";
      getQuestionCallback(
        state,
        actions,
        setState,
        nextStepName,
        history,
        lang,
        questions
      );
    }
  }
}

export async function finishQuestionCallback(
  state,
  nextStepName,
  history,
  actions,
  setState,
  questions,
  lang
) {
  backClickStatic({ state, actions, setState, nextStepName, history });
  setState({
    name: "",
    groupMultipleCheckboxSelected: [],
    isLoading: true,
  });

  actions.getTriageScoreFromAnswers({ lang });

  let flu = false;
  let comman_cold = false;
  let Acute_bronchitis = false;
  let pneumonia = false;

  localStorage.setItem("covidenabled", false);

  var countryName = checkAndGetLocalStorageValue("countryname");
  var cityName = checkAndGetLocalStorageValue("cityname");
  var provinceName = checkAndGetLocalStorageValue("statename");
  var countyName = checkAndGetLocalStorageValue("provincename");
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  const fulllocation = cityName + "," + provinceName + "," + countryName;
  const organizationid = checkAndGetLocalStorageValue("orgid");

  window.store = store;

  var response = await actions.sendTriageRequest({
    action: "GetCovidSymptoms",
    data: {
      OrganizationId: organizationid,
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
      paramsDto: {
        TagsBooleanOperator: "and",
        Tags: ["COVID-19", "Local Details Url"],
        Type: "Url",
        CityName:
          cityName !== "" &&
          (countryName == "United Kingdom" || countryName == "Canada")
            ? cityName
            : null,
        CountyName:
          countyName == "" || countryName != "United States"
            ? null
            : countyName,
        ProvinceName:
          provinceName == "" || countryName == "United Kingdom"
            ? null
            : provinceName,
        CountryName: countryName,
      },
    },
  });

  if (response && response.message === commonConstant.success) {
    var symptomsInfo = response.symptomsInfo;
    setState({
      GuidLinesInfo: symptomsInfo,
    });
    if (symptomsInfo.url == null) {
      localStorage.setItem("covidurl", defaultCovidUrl);
    } else {
      localStorage.setItem("covidurl", symptomsInfo.url);
    }
    localStorage.setItem("covidenabled", symptomsInfo.covidEnabled);
    let covidstate = checkAndGetLocalStorageValue("covidenabled");
    if (questions != null) {
      for (let i = 0; i < questions.conditions.length; i++) {
        if (questions.conditions[i].common_name == "Acute bronchitis")
          Acute_bronchitis = true;
        if (questions.conditions[i].common_name == "Common cold")
          comman_cold = true;
        if (questions.conditions[i].common_name == "Flu") flu = true;
        if (questions.conditions[i].common_name == "Pneumonia")
          pneumonia = true;
      }
    }
    if (
      Acute_bronchitis == true ||
      comman_cold == true ||
      flu == true ||
      pneumonia == true
    ) {
      if (Acute_bronchitis == true || pneumonia == true) {
        state.triageRequest.covidmsg = (
          <Trans i18nKey="findcareoption.Covid.high">
            Your symptoms are worrisome and may require immediate medical care.
            If you are unable to make It to a local emergency room, please call
            for an ambulance.
          </Trans>
        );
        state.triageRequest.covidstatus = "high";
      }

      if (comman_cold == true || flu == true) {
        state.triageRequest.covidmsg = (
          <Trans i18nKey="findcareoption.Covid.medium">
            Your symptoms suggest that you may require medical attention as well
            as being a candidate for COVID-19 testing.
          </Trans>
        );
        state.triageRequest.covidstatus = "medium";
      }
    } else {
      state.triageRequest.covidmsg = (
        <Trans i18nKey="findcareoption.Covid.low">
          Your symptoms do not suggest that you have COVID-19 infection. Still,
          it’s better if you recover from your illness at home, for your and
          other people’s safety
        </Trans>
      );
      state.triageRequest.covidstatus = "low";
    }
    if (covidstate === "true" && state.triageRequest.covidstatus !== "low") {
      nextStepName = "care-options";
    } else {
      state.triageRequest.activeMenu = "care-options";
      nextStepName = "care-options";
    }
    state.triageRequest.activeMenu = nextStepName;
    history.push(`/find-care-options/${nextStepName}`);
  }
  localStorage.setItem("careoption", "");
}
async function getQuestionCallback(
  state,
  actions,
  setState,
  nextStepName,
  history,
  lang,
  questions
) {
  const uuidv4 = require("uuid/v4");
  const questionID = uuidv4();
  if (questions != null && questions.question != null) {
    setState({
      Questions: questions,
      QuestionsID: questionID,
      QuestionOrder: questions.order,
      lastPageAddedID: [],
    });
  }

  setState({
    name: "",
    groupMultipleCheckboxSelected: [],
  });
  if (questions != null && questions.question == null) {
    state.triageRequest.activeMenu = nextStepName;
    actions.finishQuestionCallback(
      state,
      nextStepName,
      history,
      actions,
      setState,
      questions,
      lang
    );
  } else {
    history.replace("/find-care-options/questions");
    setState({
      isLoading: false,
    });
  }
}

export function getLanguage(lang) {
  let lange = !lang.args ? lang : lang.args[0];
  switch (lange) {
    case "en":
      return 1;
    case "fr":
      return 5;
    case "es":
      return 2;
    case "de":
      return 4;
    default:
      return 1;
  }
}

export function getEmergencyQuesLanguage(lang){
  let lange = !lang.args ? lang : lang.args[0];
  switch (lange){
    case "fr":
      return 64;
    case "es":
      return 75;
    case "de":
    //   return 103;
    default:
      return 4;
  }
}
function switchResult(selectedCareOptionName) {
  switch (selectedCareOptionName) {
    case 'Clinic':
      return 2;
    case 'Retail Clinic':
      return 5;
    case 'Urgent Care':
      return 3;
    case 'Emergency Room':
      return 4;
    case 'Telemedicine':
       return 6;
    case 'Decline Care':
        return 10;
    default:
      return 0;
  }
}

export function getReferenceData(state, setState, isDefault, isUserInstruction) {
  setState({
    isLoading: true,
  });
  const { triageRequest } = state;
  //const { selectedCareOptionName } = triageRequest;

  console.log("care", selectedCareOptionName);
  var selectedLanguage = checkAndGetSessionStorageValue("languageCode");
  var careOptionName = "";
  var connectionType = 0;
  var vendorOptionName = "";
  var tagName = "";
  var selectedCareOptionName = localStorage.getItem('careoption')
  switch (selectedCareOptionName) {
    case "Telemedicine":
      var vendorName =
        state.triageResponse.vendorsList[0].nameLocalization.localizations[0]
          .value;
        connectionType = state.triageResponse.selectedConnectionType;
      if (
        vendorName === telemedicineVendors.oneEightHundredMD ||
        vendorName === telemedicineVendors.Semesur ||
        vendorName === telemedicineVendors.MediOrbis
      ) {
        
        if (vendorName === telemedicineVendors.oneEightHundredMD)
          vendorOptionName = "OneEightHundred";
        else if (vendorName === telemedicineVendors.Semesur)
          vendorOptionName = telemedicineVendors.Semesur;
        else if (vendorName === telemedicineVendors.MediOrbis)
          vendorOptionName = telemedicineVendors.MediOrbis;
        if (state.triageResponse.vendorsList.length > 1) {
          for (
            let index = 0;
            index < state.triageResponse.vendorsList.length;
            index++
          ) {
            vendorName =
              state.triageResponse.vendorsList[index].nameLocalization
                .localizations[0].value;
            if (vendorName === telemedicineVendors.MediOrbis)
              vendorOptionName = "MediOrbis";
          }
        }
        if (connectionType === "1") {
          careOptionName = "Telemedicine." + vendorOptionName + ".Telephone";
        } else {
          careOptionName = "Telemedicine." + vendorOptionName + ".Video";
        }
      } else if (vendorName === telemedicineVendors.Maple) {
        careOptionName = "Telemedicine.Maple";
        vendorOptionName = telemedicineVendors.Maple;
      } else if (vendorName === telemedicineVendors.GPDQ) {
        careOptionName = "Telemedicine.GPDQ";
        vendorOptionName = telemedicineVendors.GPDQ;
      }
      break;
    case "House Visit":
      careOptionName = "HouseVisit";
      tagName = "DirectionalCare.Resource.SelfService.WhatsNext.HouseVisit";
      break;
    case "Concierge Care":
      careOptionName = "HouseVisit";
      tagName = "DirectionalCare.Resource.SelfService.WhatsNext.HouseVisit";
      break;
    case "Decline Care":
      careOptionName = "DeclineCare";
      tagName = "DirectionalCare.Resource.SelfService.WhatsNext.DeclineCare";
      break;
    default:
      careOptionName = "Facility";
      tagName = "DirectionalCare.Resource.SelfService.WhatsNext.Facility";
  }
  if (isDefault)
  {
    careOptionName = "ThankYou";
    tagName = "DirectionalCare.Resource.SelfService.WhatsNext.ThankYou";
  } 
  if(isUserInstruction)
  {
    careOptionName = "UserInstruction";
    tagName = "DirectionalCare.Resource.SelfService.WhatsNext.UserInstruction";
  } 
  if (selectedLanguage == null || selectedLanguage.length === 0) {
    selectedLanguage = "en";
  }

    const data = {
      tagName: tagName,
      coordinationType : switchResult(localStorage.getItem('careoption')),
      languageId: getLanguage(selectedLanguage),
      vendorName: vendorOptionName,
      telemedicineType: connectionType == 0 || (connectionType == 2 && vendorName == "Maple") ? null: connectionType == 1 ? "Telephone" : "Video",
    };
  return data;
}

export function updateTriageLogCoordination(state){
  const encounterToken = checkAndGetLocalStorageValue("token");
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  const data={
    coordinationType : switchResult(localStorage.getItem('careoption')),
    jwtAccessToken : jwtAccess_Token,
    accessToken : access_Token,
    identifier : state.triageRequest.sessionId,
    token : encounterToken
  }
  return data;

}

function getDataForGetDiagnosis(state, lang, isQuestionLog) {
  const { triageRequest } = state;
  let {
    sessionId,
    ageInYears,
    gender,
    presentRelatedSymptomsMap,
    absentRelatedSymptomsMap,
  } = triageRequest;
  const encounterToken = checkAndGetLocalStorageValue("token");

  let data = {};
  let genderFemale = "female";
  let genderMale = "male";
  if (gender === "F") gender = genderFemale;
  if (gender === "M") gender = genderMale;

  const presentEvidence = [];
  const absentEvidence = [];
  const unknownEvidence = [];
  if (triageRequest.pregnant === true) {
    data = { Id: "p_42", ChoiceId: "", Initial: false, source: "predefined" };
    presentEvidence.push(data);
  } else if (gender == genderConst.Female) {
    data = { Id: "p_42", ChoiceId: "", Initial: false };
    absentEvidence.push(data);
  }

  if (triageRequest.selectChildBirth === "Yes") {
    data = { Id: "p_55", ChoiceId: "", Initial: false, source: "predefined" };
    presentEvidence.push(data);
  } else if (gender == genderConst.Female) {
    data = { Id: "p_55", ChoiceId: "", Initial: false };
    absentEvidence.push(data);
  }
  for (var i = 0; i < state.currentSymptomsSortedKeys.length; i++) {
    var s1 = state.currentSymptomsSortedKeys[i];
    data = { Id: s1, ChoiceId: "", Initial: true, Source: "initial" };
    presentEvidence.push(data);
  }

  for (const key of Object.keys(presentRelatedSymptomsMap)) {
    const { id } = presentRelatedSymptomsMap[key];
    data = { Id: id, ChoiceId: "", Initial: true, source: "suggest" };
    presentEvidence.push(data);
  }

  for (var i = 0; i < state.triageRequest.locationRiskfactors.length; i++) {
    var s1 = state.triageRequest.locationRiskfactors[i];
    data = {
      Id: s1,
      ChoiceId: "present",
      Initial: false,
      source: "predefined",
    };
    presentEvidence.push(data);
  }
  for (var i = 0; i < state.presentQuestionsSelected.length; i++) {
    var s1 = state.presentQuestionsSelected[i];
    data = { Id: s1, ChoiceId: "", Initial: true };
    presentEvidence.push(data);
  }
  for (const key of Object.keys(absentRelatedSymptomsMap)) {
    const { id } = absentRelatedSymptomsMap[key];
    data = { Id: id, ChoiceId: "", Initial: true };
    absentEvidence.push(data);
  }
  for (var i = 0; i < state.absentQuestionsSelected.length; i++) {
    var s1 = state.absentQuestionsSelected[i];
    data = { Id: s1, ChoiceId: "", Initial: true };
    absentEvidence.push(data);
  }
  for (var i = 0; i < state.unknownQuestionsSelected.length; i++) {
    var s1 = state.unknownQuestionsSelected[i];
    data = { Id: s1, ChoiceId: "", Initial: true };
    unknownEvidence.push(data);
  }
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  const reqData = {
    LanguageId: getLanguage(lang),
    Age: ageInYears,
    Gender: gender,
    PresentEvidence: presentEvidence,
    AbsentEvidence: absentEvidence,
    UnknownEvidence: unknownEvidence,
    Identifier: sessionId,
    Token: encounterToken,
    QuestionLog: isQuestionLog,
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
  };
  return reqData;
}

export async function postQuestions({ state, actions, setState }) {
  const reqData = getDataForUpdateTriageLogQuestions(state);
  setState({
    isLoading: true,
  });
  await actions.sendTriageRequest({
    action: "UpdateTriageLogQuestions",
    data: reqData,
  });
}

function getDataForUpdateTriageLogQuestions(state) {
  const { triageRequest } = state;
  let { sessionId } = triageRequest;
  const encounterToken = checkAndGetLocalStorageValue("token");

  const PresentAnswers = [];
  const AbsentAnswers = [];
  const UnknownAnswers = [];

  var lastObject =
    state.questionWithAnswers[state.questionWithAnswers.length - 1];
  for (var i = 0; i < lastObject.presentQuestionsSelected.length; i++) {
    var preIndex = state.presentQuestionsSelected.indexOf(
      lastObject.presentQuestionsSelected[i]
    );
    if (preIndex > -1)
      PresentAnswers.push(lastObject.presentQuestionsSelected[i]);
  }
  for (var i = 0; i < lastObject.unknownQuestionsSelected.length; i++) {
    var unknowIndex = state.unknownQuestionsSelected.indexOf(
      lastObject.unknownQuestionsSelected[i]
    );
    if (unknowIndex > -1)
      UnknownAnswers.push(lastObject.unknownQuestionsSelected[i]);
  }
  for (var i = 0; i < lastObject.absentQuestionsSelected.length; i++) {
    var absentIndex = state.absentQuestionsSelected.indexOf(
      lastObject.absentQuestionsSelected[i]
    );
    if (absentIndex > -1)
      AbsentAnswers.push(lastObject.absentQuestionsSelected[i]);
  }
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  const reqData = {
    QuestionId: state.QuestionsID,
    QuestionOrder: state.QuestionOrder,
    PresentAnswers,
    AbsentAnswers,
    UnknownAnswers,
    Identifier: sessionId,
    Token: encounterToken,
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
  };
  return reqData;
}
